// extracted by mini-css-extract-plugin
export default {"root":"styles_root__WlAXY","label":"styles_label__BcBf6","active":"styles_active__I-wUK","selected":"styles_selected__DplsA"};